import type * as Types from "../../../graphql/graphql-generated.types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CreateReservationMutationVariables = Types.Exact<{
  createReservationInput: Types.ReserveInput;
}>;

export type CreateReservationMutation = {
  __typename?: "Mutation";
  createReservation: { __typename?: "Registration"; uuid: string };
};

export type CheckInMutationVariables = Types.Exact<{
  checkinInput: Types.CheckinInput;
}>;

export type CheckInMutation = {
  __typename?: "Mutation";
  checkin: { __typename?: "Checkin"; wasSuccessful: boolean };
};

export type JoinWaitlistMutationVariables = Types.Exact<{
  joinWaitlistInput: Types.JoinWaitlistInput;
}>;

export type JoinWaitlistMutation = {
  __typename?: "Mutation";
  joinWaitlist: { __typename?: "Registration"; uuid: string };
};

export type GetDocumentsQueryVariables = Types.Exact<{
  getDocumentsInput: Types.GetDocumentsInput;
}>;

export type GetDocumentsQuery = {
  __typename?: "Query";
  getDocuments: Array<{
    __typename?: "Document";
    uuid: string;
    signed: boolean;
  }>;
};

export const CreateReservationDocument = gql`
  mutation CreateReservation($createReservationInput: ReserveInput!) {
    createReservation(createReservationInput: $createReservationInput) {
      uuid
    }
  }
`;
export type CreateReservationMutationFn = Apollo.MutationFunction<
  CreateReservationMutation,
  CreateReservationMutationVariables
>;

/**
 * __useCreateReservationMutation__
 *
 * To run a mutation, you first call `useCreateReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReservationMutation, { data, loading, error }] = useCreateReservationMutation({
 *   variables: {
 *      createReservationInput: // value for 'createReservationInput'
 *   },
 * });
 */
export function useCreateReservationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateReservationMutation,
    CreateReservationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateReservationMutation,
    CreateReservationMutationVariables
  >(CreateReservationDocument, options);
}
export type CreateReservationMutationHookResult = ReturnType<
  typeof useCreateReservationMutation
>;
export type CreateReservationMutationResult =
  Apollo.MutationResult<CreateReservationMutation>;
export type CreateReservationMutationOptions = Apollo.BaseMutationOptions<
  CreateReservationMutation,
  CreateReservationMutationVariables
>;
export const CheckInDocument = gql`
  mutation CheckIn($checkinInput: CheckinInput!) {
    checkin(checkinInput: $checkinInput) {
      wasSuccessful
    }
  }
`;
export type CheckInMutationFn = Apollo.MutationFunction<
  CheckInMutation,
  CheckInMutationVariables
>;

/**
 * __useCheckInMutation__
 *
 * To run a mutation, you first call `useCheckInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkInMutation, { data, loading, error }] = useCheckInMutation({
 *   variables: {
 *      checkinInput: // value for 'checkinInput'
 *   },
 * });
 */
export function useCheckInMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CheckInMutation,
    CheckInMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CheckInMutation, CheckInMutationVariables>(
    CheckInDocument,
    options,
  );
}
export type CheckInMutationHookResult = ReturnType<typeof useCheckInMutation>;
export type CheckInMutationResult = Apollo.MutationResult<CheckInMutation>;
export type CheckInMutationOptions = Apollo.BaseMutationOptions<
  CheckInMutation,
  CheckInMutationVariables
>;
export const JoinWaitlistDocument = gql`
  mutation JoinWaitlist($joinWaitlistInput: JoinWaitlistInput!) {
    joinWaitlist(joinWaitlistInput: $joinWaitlistInput) {
      uuid
    }
  }
`;
export type JoinWaitlistMutationFn = Apollo.MutationFunction<
  JoinWaitlistMutation,
  JoinWaitlistMutationVariables
>;

/**
 * __useJoinWaitlistMutation__
 *
 * To run a mutation, you first call `useJoinWaitlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinWaitlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinWaitlistMutation, { data, loading, error }] = useJoinWaitlistMutation({
 *   variables: {
 *      joinWaitlistInput: // value for 'joinWaitlistInput'
 *   },
 * });
 */
export function useJoinWaitlistMutation(
  baseOptions?: Apollo.MutationHookOptions<
    JoinWaitlistMutation,
    JoinWaitlistMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    JoinWaitlistMutation,
    JoinWaitlistMutationVariables
  >(JoinWaitlistDocument, options);
}
export type JoinWaitlistMutationHookResult = ReturnType<
  typeof useJoinWaitlistMutation
>;
export type JoinWaitlistMutationResult =
  Apollo.MutationResult<JoinWaitlistMutation>;
export type JoinWaitlistMutationOptions = Apollo.BaseMutationOptions<
  JoinWaitlistMutation,
  JoinWaitlistMutationVariables
>;
export const GetDocumentsDocument = gql`
  query GetDocuments($getDocumentsInput: GetDocumentsInput!) {
    getDocuments(getDocumentsInput: $getDocumentsInput) {
      uuid
      signed
    }
  }
`;

/**
 * __useGetDocumentsQuery__
 *
 * To run a query within a React component, call `useGetDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentsQuery({
 *   variables: {
 *      getDocumentsInput: // value for 'getDocumentsInput'
 *   },
 * });
 */
export function useGetDocumentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDocumentsQuery,
    GetDocumentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDocumentsQuery, GetDocumentsQueryVariables>(
    GetDocumentsDocument,
    options,
  );
}
export function useGetDocumentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDocumentsQuery,
    GetDocumentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDocumentsQuery, GetDocumentsQueryVariables>(
    GetDocumentsDocument,
    options,
  );
}
export type GetDocumentsQueryHookResult = ReturnType<
  typeof useGetDocumentsQuery
>;
export type GetDocumentsLazyQueryHookResult = ReturnType<
  typeof useGetDocumentsLazyQuery
>;
export type GetDocumentsQueryResult = Apollo.QueryResult<
  GetDocumentsQuery,
  GetDocumentsQueryVariables
>;
